import React from "react";
import { toast } from "sonner";
import { ShareNetwork, WhatsappLogo, LinkedinLogo } from "@phosphor-icons/react";

const slug = (s) => (s || "").toLowerCase().replace(/&/g, " and ").replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
const SITE = (process.env.REACT_APP_PUBLIC_SITE_URL || window.location.origin).replace(/\/$/, "");

export const showSeoPath = (show) =>
  `/api/franchise-expos/${slug(show.country)}/${slug(show.city)}/${slug(show.name)}`;

// Share the server-rendered page so WhatsApp/LinkedIn see the branded preview card.
export const shareUrl = (show) => `${SITE}${showSeoPath(show)}`;

export const ShareButtons = ({ show }) => {
  const url = shareUrl(show);
  const text = `${show.name} — ${show.city}, ${show.country}`;

  const copy = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title: show.name, text, url });
        return;
      } catch {
        // user cancelled; fall through to copy
      }
    }
    await navigator.clipboard?.writeText(url).catch(() => {});
    toast.success("Link copied — paste it anywhere to share");
  };

  const btn =
    "inline-flex items-center gap-1.5 rounded-full border border-white/10 bg-white/5 px-3.5 py-2 text-xs font-semibold text-slate-200 transition-colors duration-200 hover:border-white/25 hover:bg-white/10";
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="share-buttons">
      <a
        data-testid="share-whatsapp-btn"
        className={btn}
        href={`https://wa.me/?text=${encodeURIComponent(`${text} ${url}`)}`}
        target="_blank"
        rel="noreferrer"
      >
        <WhatsappLogo size={15} weight="fill" className="text-emerald-400" /> WhatsApp
      </a>
      <a
        data-testid="share-linkedin-btn"
        className={btn}
        href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`}
        target="_blank"
        rel="noreferrer"
      >
        <LinkedinLogo size={15} weight="fill" className="text-sky-400" /> LinkedIn
      </a>
      <button data-testid="share-copy-btn" className={btn} onClick={copy}>
        <ShareNetwork size={15} /> Share
      </button>
    </div>
  );
};
